export const environment = {
  firebaseConfig: {
    projectId: 'digi-card-b1c32',
    appId: '1:284587018615:web:93a453f9a66ae47df2b972',
    storageBucket: 'digi-card-b1c32.appspot.com',
    apiKey: 'AIzaSyCX1iCp01_DAj-D3ekTj4iZ5-bw6X0rE7k',
    authDomain: 'digi-card-b1c32.firebaseapp.com',
    messagingSenderId: '284587018615',
    measurementId: 'G-YG8DBXXNB1',
  },
  production: true,
  useEmulator: false,
  emulatorHost: 'localhost', // Not used in production, but required for type consistency
  ZOHO_CLIENT_ID: "1000.F86RO636DM3BM77KTTGXGJ54YZ3YJR",
  ZOHO_REDIRECT_URI: "https://silencetokencreation-f7w4n766wq-uc.a.run.app",
  HUBSPOT_CLIENT_ID: "710fcbd2-2f41-4f62-bd35-7c6d14feb2ac",
  HUBSPOT_REDIRECT_URI: "https://silencetokencreation-f7w4n766wq-uc.a.run.app",
  PIPEDRIVE_CLIENT_ID: "20ffdc63783ef183",
  PIPEDRIVE_REDIRECT_URI: "https://silencetokencreation-f7w4n766wq-uc.a.run.app",
  RD_CLIENT_ID: 'deb8d433-6028-48ac-84d9-ba19fb55a1cf',
  RD_REDIRECT_URI: 'https://silencetokencreation-f7w4n766wq-uc.a.run.app',
  SALESFORCE_CLIENT_ID:
    '3MVG91oqviqJKoEFWG7tj9QrQ0OcMPBEH2OGTdgF1BcuKo2pHLOEdL9Ew8uJkDYYNJnm3NA53OqLFDNBg1Z9i',
  SALESFORCE_REDIRECT_URI:
    'https://silencetokencreation-f7w4n766wq-uc.a.run.app',
  MS_DYNAMICS_URL:
    'https://createmsauthorizeurl-f7w4n766wq-uc.a.run.app?cardID=',
  MS_DYNAMICS_URL_CALLBACK:
    '&redirectTo=https://silencetokencreation-f7w4n766wq-uc.a.run.app',
  MS_DYNAMICS_REDIRECT_URI:
    'https://silencetokencreation-f7w4n766wq-uc.a.run.app',
};
